import { ElementRef, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { RegulationFilterModel } from '../../models/regulation';

@Injectable({
  providedIn: 'root'
})
export class GeneralDataService {
  
  data = new Subject<number>();
  data$ = this.data.asObservable();
  isDivisionChange:boolean=false;

  landingComponentIdentifire = new Subject<ElementRef>();
  landingComponentIdentifire$ = this.landingComponentIdentifire.asObservable();

  getDivisionSelected():Observable<number>{
    return this.data$;
  }
  setDivisionSelected(value:number){
    return this.data.next(value);
  }

  getLandingComponentIdentifire():Observable<ElementRef>{
    return this.landingComponentIdentifire$;
  }
  setLandingComponentIdentifire(value:ElementRef){
    return this.landingComponentIdentifire.next(value);
  }
  
  private changeSATemplate = new Subject<number>();
  changeSATemplate$ = this.changeSATemplate.asObservable();

  SATemplateChanged(templateNo:number): void {
    this.changeSATemplate.next(templateNo);
  }

  constructor() { }
}
